import service from '@/utils/server';

const modName='/bd/purchArrivalPlanLog/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/bd/purchArrivalPlanLog/api/index.js